module.exports = __webpack_public_path__ + "img/example_3.70c7e927.png";